import isEqual from "lodash.isequal";
import { FieldType } from "@shared/features/form/Form";
import { makeQuizQuestionInputKey } from "../../utils/makeQuizQuestionInputKey";

export function filterFieldsByQuestionLogic(
  fields: FieldType[],
  values: Record<string, any>
) {
  return fields.filter((field) => {
    if (!("question_logic" in field) || !field.question_logic) return true;

    const { depends_on, operator, value } = field.question_logic;

    const dependentValue = values[makeQuizQuestionInputKey(depends_on)];

    switch (operator) {
      case "=":
        return dependentValue === value || isEqual(dependentValue, [value]);
      case "!=":
        return dependentValue !== value;
      case ">":
        return dependentValue > value;
      case "<":
        return dependentValue < value;
      case ">=":
        return dependentValue >= value;
      case "<=":
        return dependentValue <= value;
      default:
        return true;
    }
  });
}

export default filterFieldsByQuestionLogic;
